<mat-form-field class="w-100">
  <mat-label>{{placeholder}}</mat-label>
  <input
    matInput
    [formControl]="dispatchType"
    [matAutocomplete]="dispatchTypeList"
  />
  <button *ngIf="dispatchType.value && formIsEnabled" type="button" mat-icon-button matSuffix>
    <mat-icon class="button-clear-filter"
      (click)="cleanDispatchType()"
      matTooltip="Borrar"
    >highlight_off</mat-icon>
  </button>
  <mat-autocomplete
    (optionSelected)="changeSelectDispatchTYpe()"
    #dispatchTypeList="matAutocomplete"
    [displayWith]="displayFnDispatchType"
  >
    <mat-option
      *ngFor="
        let dispatchType of dispatchTypeAutocompleteList | async"
      [value]="dispatchType"
    >
      <span> {{ dispatchType.configName }} </span>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
